import { render, staticRenderFns } from "./news2.vue?vue&type=template&id=f6c37c2c&scoped=true&"
import script from "./news2.vue?vue&type=script&lang=js&"
export * from "./news2.vue?vue&type=script&lang=js&"
import style0 from "./news2.vue?vue&type=style&index=0&id=f6c37c2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c37c2c",
  null
  
)

export default component.exports